export const growStyle = placement => ({
  transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom'
});